import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WMCountdownBanner from "@/components/WMCountdownBanner";
import ProductGrid from "@/components/ProductGrid";
import About from "@/components/About";
import InstagramFeed from "@/components/InstagramFeed";
import Newsletter from "@/components/Newsletter";
import Footer from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <WMCountdownBanner />
        <ProductGrid />
        <About />
        <InstagramFeed />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
